import { useState } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { isSecretFragmentPath } from './App/Shared/lib/receiptPrivacy';
import { maskPayLinkTokens } from './App/Shared/lib/analytics/maskPayLinkTokens';

export const PostHogAnalytics = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // The public receipt (/r#<secret>), invite claim (/claim#<token>) and
  // password reset (/password-reset#<token>) pages
  // carry a bearer secret in the URL, which autocapture and session replay
  // would record — so PostHog is never initialised there.
  //
  // This checks the path once, at page load, and does not follow later
  // navigation. That holds because these pages are always opened fresh from a
  // scanned or emailed link. After the claim, the in-app move to /dashboard
  // leaves PostHog off until the next reload; an in-app link to any of them
  // would need this to track the route.
  const [onReceiptPage] = useState(() => isSecretFragmentPath(window.location.pathname));

  if (!window.initialData?.PostHogKey || onReceiptPage) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={window.initialData?.PostHogKey}
      options={{
        api_host: window.initialData?.PostHogUrl,
        capture_pageview: 'history_change',
        before_send: maskPayLinkTokens,
      }}
    >
      {children}
    </PostHogProvider>
  );
};
